import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.less']
})
export class ContactDetailsComponent implements OnInit {

  @Input('details') details: any;

public magShow:Boolean = false;
public eventShow:Boolean = false;
public roleShow:Boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
